module.exports = __webpack_public_path__ + "images/179d18a18315448c23752168ece56cfa-illu_smokeSensor3.svg";